// extracted by mini-css-extract-plugin
export default {"label":"ChartHeader_label__TqqsB","value":"ChartHeader_value__TOxOK"};